export const defaultComment = {
  commentId: null,
  parentCommentId: null,
  commentText: "",
  parentCommentText: null,
  internal: false,
  recipients: []
};
